import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { useState } from 'react';
import Chip from '../../atoms/Chip/Chip.js';
import Preloader from '../../atoms/Preloader/Preloader.js';
import { classnames } from '../../../utils/classnames.js';
import { downloadWithLoading } from '../../../utils/download.js';
import './Attachment.scss.js';

var Attachment = function Attachment(_a) {
  var attachment = _a.attachment,
      _a$showRemoveIcon = _a.showRemoveIcon,
      showRemoveIcon = _a$showRemoveIcon === void 0 ? true : _a$showRemoveIcon,
      onRemove = _a.onRemove,
      className = _a.className,
      props = __rest(_a, ["attachment", "showRemoveIcon", "onRemove", "className"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  if (!attachment) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-attachment', className),
    "data-v-6e52f9c7": ""
  }, isLoading && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-attachment__loader",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(Preloader, {
    size: "s",
    "data-v-6e52f9c7": ""
  })), /*#__PURE__*/React__default.createElement(Chip, _extends({
    onClick: function onClick() {
      return downloadWithLoading(attachment, setIsLoading);
    },
    size: "s",
    type: "outline",
    maxLength: 30,
    tooltipBackground: "white",
    onRemove: showRemoveIcon ? function () {
      return onRemove === null || onRemove === void 0 ? void 0 : onRemove(attachment);
    } : undefined,
    iconPosition: "right"
  }, props, {
    "data-v-6e52f9c7": ""
  }), attachment.file.name));
};

export { Attachment as default };
